export default {
  back: 'Back to seat configuration',
  backShort: 'Back',
  title: 'Seat arrangement',
  stepArrange: 'Arrangement',
  stepLayout: 'Venue layout',
  stepSeating: 'Seat assignment',
  editorModes: 'Editor mode',
  progress: '{assigned} / {total} seats assigned',
  unsaved: 'Unsaved changes',
  save: 'Save',
  lastSaved: 'Auto-saved at {time}',
  notSaved: 'Not saved yet',
  rosterTitle: 'Participant roster',
  rosterProgress: '{assigned} / {total} assigned',
  newPending: '{count} new participants to assign',
  addMembers: 'Add roster',
  addRoster: 'Import roster',
  importRegistration: 'Import registrants',
  registrationImportSuccess: 'Registrants synced: {added} added, {removed} removed',
  registrationImportEmpty: 'No changes in the registration roster',
  saveBeforeRoster: 'Save the current seat changes before importing a roster',
  saveBeforePrint: 'Save the current seat changes before printing',
  saveLayoutBeforeSwitchConfirm: 'The venue layout has unsaved changes. Save them and switch to seat assignment?',
  saveAndSwitch: 'Save and switch',
  sortLabel: 'Sort by',
  sortShort: 'Sort',
  sortForm: 'Form order',
  sortName: 'Name',
  sortDept: 'Department',
  sortUnassigned: 'Default (unassigned first)',
  sortNameAsc: 'Name A-Z',
  sortNameDesc: 'Name Z-A',
  sortOrganization: 'Organization / name',
  sortSeat: 'Seat order',
  autoFill: 'Auto-fill',
  autoFillHint: 'Keep assigned seats and fill empty seats with unassigned participants in the selected order (locked seats are excluded)',
  lockMode: 'Seat lock · VIP seats',
  lockModeOn: 'Seat lock · On',
  finishVipLock: 'Finish VIP seat setup',
  finishVipLockHint: 'Save VIP seat settings and exit lock mode',
  lockModeHint: 'Click an empty seat to reserve it for VIPs; click again to unlock',
  lockSeatAssigned: 'This seat is occupied and cannot be reserved for VIPs',
  lockBannerTitle: 'Seat lock mode is on',
  lockBannerSub: 'Click an empty seat to reserve it for VIPs; click a locked seat to unlock it. Locked seats are skipped during auto-fill.',
  lockedSeatCount: '{count} seats locked',
  exitLock: 'Exit lock mode',
  vipLockHint: 'Click an empty seat to set or cancel VIP locking. Locked positions accept VIPs only. Close this mode when finished.',
  searchRoster: 'Search name / organization / job title',
  noOrganization: 'No organization',
  unassigned: 'Unassigned',
  seatPosition: '{unit} · Seat {no}',
  noRosterMatch: 'No matching participants',
  emptyRoster: 'No participants yet',
  canvasTip: 'Drag a participant from the left to assign. Long-press an assigned seat to move it; drop on another assigned seat to swap.',
  properties: 'Properties',
  available: 'Available',
  seatDetails: 'Seat details',
  unit: 'Table',
  row: 'Row',
  column: 'Column',
  rowValue: 'Row {row}',
  columnValue: 'Column {column}',
  seatNo: 'Seat number',
  seatNumberValue: 'Seat {no}',
  phone: 'Phone',
  status: 'Status',
  lockedTag: 'Locked',
  assigned: 'Assigned',
  empty: 'Empty',
  clearAssignment: 'Clear seat assignment',
  emptySeatHint: 'Drag a participant from the left',
  emptySeatHintSecond: 'to assign this seat',
  selectSeat: 'Select a seat or table to view details',
  seatOccupied: 'This seat is already assigned',
  saveSuccess: 'Seat assignments saved',
  sources: {
    registration: 'Registration',
    imported: 'Imported'
  }
}
